import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import NotFound from 'components/NotFound';
import PageWithSidebar from 'components/PageWithSidebar';
import EntitySidebar from 'components/EntitySidebar';
import ServiceGroupEditTabs from 'components/ServiceGroupEditTabs';

import { withData } from 'lib';
import { SettingsServiceGroupEditPageQuery } from '__generated__/SettingsServiceGroupEditPageQuery.graphql';

const query = graphql`
  query SettingsServiceGroupEditPageQuery($id: ID!) {
    serviceGroup(id: $id) {
      name

      ...EntitySidebar_entity
      ...ServiceGroupEditTabs_serviceGroup
    }
  }
`;

type RouteParams = {
  id: string;
};

type Props = {
  preloadedQuery: PreloadedQuery<SettingsServiceGroupEditPageQuery>;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  {
    link: '/settings/service-groups',
    name: 'Papildomų paslaugų paketai',
  },
];

const SettingsServiceGroupEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { serviceGroup } = usePreloadedQuery<SettingsServiceGroupEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!serviceGroup) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<EntitySidebar entity={serviceGroup} />}
      breadcrumbs={[...breadcrumbs, { name: serviceGroup.name }]}>
      <ServiceGroupEditTabs serviceGroup={serviceGroup} />
    </PageWithSidebar>
  );
};

export default withData<SettingsServiceGroupEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(SettingsServiceGroupEditPage);
